import { default as _91slug_93rD5ORMWVlMMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/[slug].vue?macro=true";
import { default as about_45us7S2S5lTc9HMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about-us.vue?macro=true";
import { default as aboutvIvhics81HMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about.vue?macro=true";
import { default as indexSShedG6mMdMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46page_93HXlOKasUAiMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/page/[...page].vue?macro=true";
import { default as _91slug_93gf3TxL7bMRMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog2/[slug].vue?macro=true";
import { default as careerslgoxRgOAitMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/careers.vue?macro=true";
import { default as index3BgeDyicYuMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/index.vue?macro=true";
import { default as _91_46_46_46page_930Ygm62SMdZMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/page/[...page].vue?macro=true";
import { default as _91_46_46_46params_93sB5r7j9UBKMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-expert/[...params].vue?macro=true";
import { default as _91_46_46_46params_93m7MyWwA8Q3Meta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-partner/[...params].vue?macro=true";
import { default as contactTChVVoDEegMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/contact.vue?macro=true";
import { default as e_45signature_45successfGRnk89DXDMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature-success.vue?macro=true";
import { default as e_45signaturecuc5zFVneiMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature.vue?macro=true";
import { default as indexzmpoJTDj2JMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/index.vue?macro=true";
import { default as survey_45successt7hcaUsHcoMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey-success.vue?macro=true";
import { default as surveyG5kcyVq8LjMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey.vue?macro=true";
import { default as indexmgxABMqby9Meta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/index.vue?macro=true";
import { default as salesforce_45wordpress_45integration_45usaAmWDaQlq3lMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration-usa.vue?macro=true";
import { default as salesforce_45wordpress_45integrationadvcH0JotSMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration.vue?macro=true";
import { default as indexR921dhhXBDMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/index.vue?macro=true";
import { default as pdf_45generation_45guide4nVbdkJUqqMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/pdf-generation-guide.vue?macro=true";
import { default as salesforce_45pdf_45buildertUzdPRlwItMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-pdf-builder.vue?macro=true";
import { default as salesforce_45web_45to_45case_45form_45buildergKKNqbuxN7Meta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-case-form-builder.vue?macro=true";
import { default as salesforce_45web_45to_45lead_45form_45builderOKbI1twv6MMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-lead-form-builder.vue?macro=true";
import { default as web_45to_45case_45guideCftZXobVctMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-case-guide.vue?macro=true";
import { default as web_45to_45lead_45guideIxvTAMM9woMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-lead-guide.vue?macro=true";
import { default as component_45stubdY2Tlw8WeAMeta } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubdY2Tlw8WeA } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93rD5ORMWVlMMeta || {},
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/[slug].vue").then(m => m.default || m)
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "blog-page-page",
    path: "/blog/page/:page(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog/page/[...page].vue").then(m => m.default || m)
  },
  {
    name: "blog2-slug",
    path: "/blog2/:slug()",
    meta: _91slug_93gf3TxL7bMRMeta || {},
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/blog2/[slug].vue").then(m => m.default || m)
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/careers.vue").then(m => m.default || m)
  },
  {
    name: "category-category",
    path: "/category/:category()",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "category-category-page-page",
    path: "/category/:category()/page/:page(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/category/[category]/page/[...page].vue").then(m => m.default || m)
  },
  {
    name: "connect-sfdc-expert-params",
    path: "/connect/sfdc-expert/:params(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-expert/[...params].vue").then(m => m.default || m)
  },
  {
    name: "connect-sfdc-partner-params",
    path: "/connect/sfdc-partner/:params(.*)*",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/connect/sfdc-partner/[...params].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "demo-e-signature-success",
    path: "/demo/e-signature-success",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature-success.vue").then(m => m.default || m)
  },
  {
    name: "demo-e-signature",
    path: "/demo/e-signature",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/e-signature.vue").then(m => m.default || m)
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/index.vue").then(m => m.default || m)
  },
  {
    name: "demo-survey-success",
    path: "/demo/survey-success",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey-success.vue").then(m => m.default || m)
  },
  {
    name: "demo-survey",
    path: "/demo/survey",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/demo/survey.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-wordpress-integration-usa",
    path: "/services/salesforce-wordpress-integration-usa",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration-usa.vue").then(m => m.default || m)
  },
  {
    name: "services-salesforce-wordpress-integration",
    path: "/services/salesforce-wordpress-integration",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/services/salesforce-wordpress-integration.vue").then(m => m.default || m)
  },
  {
    name: "tools",
    path: "/tools",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: "tools-pdf-generation-guide",
    path: "/tools/pdf-generation-guide",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/pdf-generation-guide.vue").then(m => m.default || m)
  },
  {
    name: "tools-salesforce-pdf-builder",
    path: "/tools/salesforce-pdf-builder",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-pdf-builder.vue").then(m => m.default || m)
  },
  {
    name: "tools-salesforce-web-to-case-form-builder",
    path: "/tools/salesforce-web-to-case-form-builder",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-case-form-builder.vue").then(m => m.default || m)
  },
  {
    name: "tools-salesforce-web-to-lead-form-builder",
    path: "/tools/salesforce-web-to-lead-form-builder",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/salesforce-web-to-lead-form-builder.vue").then(m => m.default || m)
  },
  {
    name: "tools-web-to-case-guide",
    path: "/tools/web-to-case-guide",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-case-guide.vue").then(m => m.default || m)
  },
  {
    name: "tools-web-to-lead-guide",
    path: "/tools/web-to-lead-guide",
    component: () => import("/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/pages/tools/web-to-lead-guide.vue").then(m => m.default || m)
  },
  {
    name: component_45stubdY2Tlw8WeAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubdY2Tlw8WeA
  }
]